import React from "react";

import UnlockedSessionCard from "../SessionCards/UnlockedSessionCard";

const UpcomingSession = ({ upcomingKeyNoteSessions, setIsPreviousSession }) => {
    return <UnlockedSessionCard session={upcomingKeyNoteSessions} setIsPreviousSession={setIsPreviousSession} />;
};

export default UpcomingSession;
